/**
 * Utility functions for table operations
 */

// Format template name for display (e.g. overall_design → Overall Design)
export const formatTableName = (name) => {
  return name
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

// Get abbreviation for template name (e.g. overall_design → OD)
export const getTableAbbreviation = (name) => {
  return name
    .split("_")
    .map((w) => w[0]?.toUpperCase() || "")
    .join("");
};

// Format table name for backend (spaces to underscores, lowercase)
export const formatTableNameForBackend = (name) => {
  return name
    .toLowerCase()
    .replace(/\s+/g, '_');
};

// Parse table columns safely
export const parseTableColumns = (columnValue) => {
  try {
    return columnValue ? 
      (typeof columnValue === 'string' ? JSON.parse(columnValue) : columnValue) 
      : [];
  } catch (e) {
    console.error('Error parsing table columns:', e);
    return [];
  }
};

// Parse table rows safely
export const parseTableRows = (rowsValue) => {
  try {
    return rowsValue ? 
      (typeof rowsValue === 'string' ? JSON.parse(rowsValue) : rowsValue) 
      : [];
  } catch (e) {
    console.error('Error parsing table rows:', e);
    return [];
  }
};

// Generate unique column ID
export const generateColumnId = (existingColumns) => {
  return `col${existingColumns.length + 1}`;
};

// Create new column object
export const createNewColumn = (existingColumns, label = null, type = 'text') => {
  const id = generateColumnId(existingColumns);
  return {
    id,
    label: label || `Column ${existingColumns.length + 1}`,
    type,
    isActions: type === 'actions'
  };
};

// Create new row object for custom table
export const createNewRow = (columns) => {
  const newRow = {};
  columns.forEach(col => {
    if (!col.isActions) {
      newRow[col.id] = '';
    }
  });
  return newRow;
};

// Filter out actions columns
export const filterNonActionColumns = (columns) => {
  return columns.filter(col => !col.isActions);
};

// Get column keys for display
export const getColumnKeys = (columns) => {
  return Array.isArray(columns) 
    ? columns.map((col, idx) => col.id || `col${idx+1}`) 
    : Object.keys(columns);
};

// Get column labels for display
export const getColumnLabels = (columns) => {
  return Array.isArray(columns) 
    ? columns.map((col, idx) => col.label || col.id || `col${idx+1}`) 
    : getColumnKeys(columns);
};
